module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/iswmMgt/custom/deviceDetails.component.css
// module id = ./src/app/iswmMgt/custom/deviceDetails.component.css
// module chunks = main